import RequireUserMiddleware from 'middlewares/RequireUserMiddleware'
import RequireSignupFinishedMiddleware from 'middlewares/RequireSignupFinishedMiddleware'
import RequirePracticeMasterUserMiddleware from 'middlewares/RequirePracticeMasterUserMiddleware'
import RequirePhysicianOrMasterUserMiddleware from 'middlewares/RequirePhysicianOrMasterUserMiddleware'
import RequirePracticeAncillaryMiddleware from 'middlewares/RequirePracticeAncillaryMiddleware'

export default [
    {
        path: '/practice/members',
        name: 'practice.members',
        view: 'practice/PracticeMembers',
        default: { query: { limit: 6 } },
        middlewares: [RequireSignupFinishedMiddleware, RequirePracticeMasterUserMiddleware, RequireUserMiddleware],
    },
    {
        path: '/practice/profile',
        name: 'practice.profile',
        view: 'practice/PracticeProfile',
        middlewares: [
            RequireSignupFinishedMiddleware,
            RequirePracticeMasterUserMiddleware,
            RequirePhysicianOrMasterUserMiddleware,
            RequireUserMiddleware,
        ],
    },
    {
        path: '/practice/profile-ancillary',
        name: 'practice.profile-ancillary',
        view: 'practice/PracticeProfileAncillary',
        middlewares: [
            RequireSignupFinishedMiddleware,
            RequirePracticeMasterUserMiddleware,
            RequireUserMiddleware,
            RequirePhysicianOrMasterUserMiddleware,
            RequirePracticeAncillaryMiddleware,
        ],
    },
    {
        path: '/practice/insurance',
        name: 'practice.insurance',
        view: 'practice/InsurancePlans',
        default: { query: { limit: 6 } },
        middlewares: [RequireSignupFinishedMiddleware, RequirePracticeMasterUserMiddleware, RequireUserMiddleware],
    },
    {
        path: '/practice/services',
        name: 'practice.services',
        view: 'practice/PracticeAncillaryServices',
        default: { query: { limit: 6 } },
        middlewares: [RequireSignupFinishedMiddleware, RequirePracticeMasterUserMiddleware, RequireUserMiddleware],
    },
    {
        path: '/practice/service/:serviceId/tests',
        name: 'practice.service.tests',
        view: 'practice/PracticeAncillaryServiceTests',
        default: { query: { limit: 6 } },
        middlewares: [
            RequireSignupFinishedMiddleware,
            RequirePracticeMasterUserMiddleware,
            RequireUserMiddleware,
            RequirePracticeAncillaryMiddleware,
        ],
    },
    {
        path: '/practice/service/:serviceId/location/:locationId/tests/modify',
        name: 'practice.service.tests.modify',
        view: 'practice/PracticeAncillaryServiceTestsModify',
        default: { query: { limit: 6 } },
        middlewares: [
            RequireSignupFinishedMiddleware,
            RequirePracticeMasterUserMiddleware,
            RequireUserMiddleware,
            RequirePracticeAncillaryMiddleware,
        ],
    },
    {
        path: '/practice/locations',
        name: 'practice.locations',
        view: 'practice/PracticeLocations',
        default: { query: { limit: 6 } },
        middlewares: [RequireSignupFinishedMiddleware, RequirePracticeMasterUserMiddleware, RequireUserMiddleware],
    },
    {
        path: '/practice/billing',
        name: 'practice.billing',
        view: 'practice/PracticeBilling',
        default: { query: { limit: 6 } },
        middlewares: [RequireSignupFinishedMiddleware, RequirePracticeMasterUserMiddleware, RequireUserMiddleware],
    },
    {
        path: '/company/create',
        name: 'company.create',
        view: 'practice/CreateCompany',
        middlewares: [RequireSignupFinishedMiddleware, RequireUserMiddleware],
    },
]
